import Date from './Date';

export { type DateProps } from './Date';
export default Date;
